import { Http, Url, Storage, GraphQlClient } from '@intelipost-js/secure-providers';
import { ScToast } from '@intelipost-js/secure-components';

export default {
  getUser({ commit }) {
    commit('toggleLoading', true);

    const user = Storage.get('user');
    const pathParams = [user.id];

    return Http.get(Url.toQueryString('api/v1/admin_user', null, pathParams))
    .then((res) => {
      const {
        data,
      } = res || {};
      const {
        content,
      } = data || {};
      commit('setForm', content);
      commit('toggleLoading', false);
      return Promise.resolve(content);
    })
    .catch((error) => {
      commit('toggleLoading', false);
      return Promise.reject(error);
    });
  },

  updateUser({ state, commit, dispatch }, form) {
    const {
      new_password = null,
      old_password = null,
    } = form;
    const promises = [dispatch('updateUserInfo', { userInfo: form })];

    commit('toggleLoading', true);

    if (new_password && old_password) {
      promises.push(dispatch('updateUserPassword', form));
    }

    return Promise.all(promises).then((userInfo = {}, passwordInfo = {}) => {
      const { res = {} } = passwordInfo;

      if (res && res.status === 200) {
        commit('setForm', Object.assign({}, form, {
          old_password: null,
          new_password: null,
          new_password_confirmation: null,
        }));
      }
      commit('toggleLoading', false);
      ScToast.success('Seus dados foram atualizados com sucesso');
    }).catch(() => commit('toggleLoading', false));
  },

  updateUserInfo(context, { userInfo }) {
    const {
      id,
    } = userInfo;
    const pathParams = [id];
    return Http.put(Url.toQueryString('api/v1/admin_user', null, pathParams), userInfo);
  },

  updateUserPassword(context, { new_password, old_password }) {
    return Http.post('api/v1/admin_user/password_update', { new_password, old_password });
  },

  getPasswordRules({ commit }) {
    commit('toggleLoading', true);

    return Http.get('/api/v1/user/password/rules')
      .then(({ data }) => {
        const {
          content = {},
        } = data || {};

        commit('toggleLoading', false);

        return Promise.resolve(content);
      });
  },

  getConnectedUser({ commit }) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query{
      getConnectedUser {
        first_name
        last_name
        email
      }
    }`).then(({ data }) => {
      const { getConnectedUser } = data;
      commit('setForm', getConnectedUser);
      commit('toggleLoading', false);
      return Promise.resolve(getConnectedUser);
    })
    .catch((error) => {
      commit('toggleLoading', false);
      return Promise.reject(error);
    });
  },

  updateConnectedUser({ commit }, connectedUser) {
    commit('toggleLoading', true);

    return GraphQlClient.mutation(`
    mutation (
      $first_name: String!
      $last_name: String!
      $email: String!
    ) {
      updateConnectedUser (
        first_name: $first_name
        last_name: $last_name
        email: $email
      ) {
        email
      }
    }`, connectedUser).then(() => {
      commit('toggleLoading', false);
      ScToast.success('Seus dados foram atualizados com sucesso');
    }).catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/user-information/store/actions.js